module.exports = __webpack_public_path__ + "static/logo-ffa0e76c38c49cedf6e2ee2df485a69c.png";